/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import BaseComponent from 'scripts/BaseComponent.js';
import Cart from '../cart';

export default class CartItem extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      qtySelector: '.js-qtySelector',
      minusQtyBtn: '.js-minusQtyBtn',
      addQtyBtn: '.js-addQtyBtn',
      removeBtn: '.js-removeBtn',
      sellingPlanSelector: '.js-sellingPlanSelector',
    };

    this.dom = {
      $component: component,
      $qtySelector: this.$get(this.refs.qtySelector),
      $minusQtyBtn: this.$get(this.refs.minusQtyBtn),
      $addQtyBtn: this.$get(this.refs.addQtyBtn),
      $removeBtn: this.$get(this.refs.removeBtn),
      $sellingPlanSelector: this.$get(this.refs.sellingPlanSelector),
    };

    this.state = {
      key: null,
      quantity: null,
      associatedProductKey: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    const { dom } = this;
    super.mount();

    if (dom.$qtySelector) {
      this.setClick(dom.$minusQtyBtn, this.minusQuantity);
      this.setClick(dom.$addQtyBtn, this.addQuantity);
    }

    this.setClick(dom.$removeBtn, this.removeProduct);

    if (dom.$sellingPlanSelector) {
      this.setOnEventWithElement('change', dom.$sellingPlanSelector, this.updateSellingPlan);
    }
  }

  init() {
    this.setState();
  }

  setState() {
    const { dom, state } = this;
    const {
      key, quantity, associatedProductKey,
    } = dom.$component.dataset;

    state.key = key;
    state.associatedProductKey = associatedProductKey;
    state.quantity = parseInt(quantity, 10);
  }

  minusQuantity() {
    const { state } = this;
    Cart.updateItem(state.key, state.quantity - 1);
  }

  addQuantity() {
    const { state } = this;
    Cart.updateItem(state.key, state.quantity + 1);
  }

  async updateSellingPlan(sellingPlanSelector) {
    const { state } = this;
    const newSellingPlanId = sellingPlanSelector.value ? sellingPlanSelector.value : null;
    await Cart.updateSubscription(1, newSellingPlanId, state.quantity);
  }

  async removeProduct() {
    const { state } = this;
    await Cart.updateItem(state.key, 0);
    if (state.associatedProductKey) {
      const keys = state.associatedProductKey.split(',');
      for (const key of keys) {
        await Cart.updateItem(key, 0);
      }
    }
  }
}
